import { Callout } from "../components/Callout.js";
import { ScreenshotBox } from "../components/ScreenshotBox.js";

export const meta = {
  title: "料金・プラン変更",
  updatedAt: "2026-07-23",
};

export function Content() {
  return (
    <>
      <h2>料金プラン</h2>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0" }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={th()}>プラン</th>
            <th style={th()}>月間送信数</th>
            <th style={th()}>月額（税別）</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={td()}>Starter</td><td style={td()}>30 件</td><td style={td()}>¥4,980</td></tr>
          <tr><td style={td()}>Professional</td><td style={td()}>100 件</td><td style={td()}>¥9,800</td></tr>
          <tr><td style={td()}>Enterprise</td><td style={td()}>送信無制限</td><td style={td()}>¥19,800</td></tr>
        </tbody>
      </table>
      <p style={{ fontSize: 12, color: "#6b6b68", marginTop: -6 }}>
        表示価格はすべて税別です。決済時に消費税 10% が加算されます。
      </p>

      <Callout type="info" title="無料トライアル">
        ご登録から <strong>14 日間は無料トライアル</strong>として、Professional プラン相当
        （月 100 件）まで送信できます。クレジットカードの登録は不要で、トライアル終了によって
        自動で課金されることはありません。トライアル終了後は、プランにお申し込みいただくまで
        書類の送信ができません（接続設定などはそのままご利用いただけます）。
      </Callout>

      <h2>プラン変更の手順</h2>
      <p>
        ダッシュボードの「<strong>プラン・請求</strong>」タブから操作します。
      </p>
      <ScreenshotBox src="/guide/screenshots/billing-1.png" caption="プラン選択画面" />

      <h3>新規契約（初回）</h3>
      <ol>
        <li>希望プランを選択</li>
        <li>「◯◯で開始」（プラン名入りのボタン）をクリック → Stripe Checkout 画面に遷移</li>
        <li>クレジットカード情報を入力</li>
        <li>決済完了後、ダッシュボードに戻る → プラン有効化</li>
      </ol>

      <h3>プラン変更（既に契約済）</h3>
      <p>
        「請求・明細の管理」セクションの「支払い方法を変更」から Stripe のポータルに
        遷移し、プラン変更を行います。アップグレード / ダウングレードどちらも即時反映で
        日割り精算されます。
      </p>

      <h3>解約</h3>
      <p>
        Stripe のカスタマーポータルから「サブスクリプションを解約」を選びます。
        契約期間終了時に解約となり、それまでは引き続き利用可能。
      </p>

      <h2>支払い方法</h2>
      <ul>
        <li>クレジットカード決済（推奨、即時開通）</li>
        <li>請求書払い（銀行振込）: 別途対応、<a href="/contact">お問い合わせフォーム</a>からご相談ください</li>
      </ul>

      <h2>請求書・領収書</h2>
      <p>
        毎月の請求書は Stripe から自動でメール送付されます。過去分は
        「請求・明細の管理」セクションの「請求履歴・領収書を確認」からいつでも
        ダウンロードできます。
      </p>

      <h2>送信数の確認</h2>
      <p>
        「プラン・請求」タブの上部に、今回の請求期間の利用状況が表示されます:
      </p>
      <ul>
        <li>今回の請求期間の送信件数 / 月間上限（請求期間と次のリセット日）</li>
        <li>請求見込み額（プランによる固定額・税別）</li>
      </ul>

      <Callout type="warning" title="上限到達後の送信">
        上限に達すると、その月はそれ以上送信できません。継続して送信するには上位プランへの変更が必要です。
        70% / 90% / 100% の到達時に自動で通知メールとベル通知が届きます。
        詳しくは <a href="/guide/usage-limits">送信上限と請求</a> を参照。
      </Callout>
    </>
  );
}

function th() {
  return { textAlign: "left" as const, padding: "8px 12px", borderBottom: "1px solid #d0cfc9", fontSize: 13 };
}
function td() {
  return { padding: "8px 12px", borderBottom: "1px solid #f0efeb", fontSize: 13 };
}
